import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollPeriod  {
    _originalTypeClassName = "zERP.BO.PayrollPeriod";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollPeriod.translate = translateService;
}
this.Calculations = [];
this.Id = null;
this.Year = null;
this.Name = null;
this.From = null;
this.To = null;
this.Weight = null;
this.IsClosed = false;
this.DateClosed = null;
this.EapPeriod = null;
this.EapIncomeType = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Year:any;
Name:any;
From:any;
To:any;
Weight:any;
IsClosed:any;
DateClosed:any;
EapPeriod:any;
EapIncomeType:any;
Type:any;
Calculations:any;
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setCalculations = ($this, items) => {
                if (items == null) items = [];
                if ($this.Calculations == null) $this.Calculations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Calculations.length > 0) {
                    Domain.PayrollPeriod.removeCalculations($this, $this.Calculations[0]);
                }

                Domain.PayrollPeriod.addManyCalculations($this, copyItems);
            }
static addManyCalculations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollPeriod.addCalculations($this, items[i]);
                }
            }
static addCalculations = ($this, item) => {
                if ($this.Calculations == null) $this.Calculations = [];
                if (item == null || $this.Calculations.indexOf(item) > -1) return;
                $this.Calculations.push(item);
if (item.Period != $this) {
Domain.PayrollCalculation.setPeriod(item, $this);
}
}
static addRangeCalculations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollPeriod.addCalculations($this, item));
            }
static removeCalculations = ($this, item) => {
                if ($this == null || $this.Calculations == null || $this.Calculations.indexOf(item) === -1) return;
                var _index = $this.Calculations.indexOf(item);
                $this.Calculations.splice(_index, 1);
item.Period = null;
}
static clearCalculations = ($this) => { $this.Calculations = null; }

static GetMonthName(monthIndex: any,locale: any): any{if (CLMS.Framework.Number.Equal(() => monthIndex, () => 1)) {return "Ιανουάριος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 2)) {return "Φεβρουάριος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 3)) {return "Μάρτιος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 4)) {return "Απρίλιος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 5)) {return "Μάιος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 6)) {return "Ιούνιος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 7)) {return "Ιούλιος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 8)) {return "Αύγουστος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 9)) {return "Σεπτέμβριος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 10)) {return "Οκτώβριος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 11)) {return "Νοέμβριος";}
if (CLMS.Framework.Number.Equal(() => monthIndex, () => 12)) {return "Δεκέμβριος";}
return "Αγνωστος μήνας " + Joove.Common.safeNumber(monthIndex);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}